module.exports = __webpack_public_path__ + "static/img/group@3x.3499f2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group@3x.jpg
// module id = QKob
// module chunks = 6